import React from 'react';
import { Icon } from '@hz-design-system/web-ui';
import { useI18nContext } from '@ecg-marktplaats/js-react-i18n';

import Classes from './SellTips.scss';

const TIP_KEYS = ['tip1', 'tip2', 'tip3', 'tip4', 'tip5', 'tip6'] as const;

const SellTips = () => {
  const { t } = useI18nContext();

  return (
    <section className={`PageContent-card PageContent-offset ${Classes.root}`}>
      <div className={Classes.heading}>
        <h2 className={Classes.title}>{t('sell.page.tips.title')}</h2>
        <p className={Classes.subtitle}>{t('sell.page.tips.subtitle')}</p>
      </div>
      <ul className={Classes.grid}>
        {TIP_KEYS.map((key) => (
          <li key={key} className={Classes.tip}>
            <div className={Classes.iconWrap}>
              <Icon name="checkmark" color="action" />
            </div>
            <h3 className={Classes.tipTitle}>{t(`sell.page.tips.${key}.title`)}</h3>
            <p className={Classes.tipBody}>{t(`sell.page.tips.${key}.body`)}</p>
          </li>
        ))}
      </ul>
    </section>
  );
};

export default SellTips;
